import { Injectable } from '@angular/core';
import { getApp } from '@angular/fire/app';
import { getAuth, signInWithCustomToken } from '@angular/fire/auth';

@Injectable({ providedIn: 'root' })
export class FirebaseAuthService {
    constructor() { }

    async signInWithCustomToken(customToken: string) {
        try {
            const app = getApp();
            const auth = getAuth(app);
            const userCredential = await signInWithCustomToken(auth, customToken.trim());
            console.log('✅ Firebase Auth successful:', userCredential.user);
            return userCredential.user;
        } catch (error) {
            console.error('❌ Firebase Auth failed:', error);
            throw error;
        }
    }
}
